import {Injectable} from '@angular/core';
import {BaseDao} from './dao/base.dao';
import {SearchBoxResponseModel} from '../model/view/SearchBoxResponseModel';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SearchBoxService {

  constructor(
    private baseDao: BaseDao<SearchBoxResponseModel>
  ) {
  }

  public getSearchBoxResult(
    searchValue: string,
    token: string = ''
  ): Observable<SearchBoxResponseModel> {
    const url: string = environment.links.searchBox.response;
    const query = {
      term : searchValue,
      token : token
    };

    const params = [];

    return <Observable<SearchBoxResponseModel>>this.baseDao.get(url, params, query, () => new SearchBoxResponseModel())
      .pipe(
        map((_oldModel) => {
          if (_oldModel.hasOwnProperty('suggestions')) {
            return SearchBoxResponseModel.convertFromOld(_oldModel);
          }

          return _oldModel;
        })
      );
  }
}
